module.exports = __webpack_public_path__ + "img/location-tip.e145a16e.png";